import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import i18n from '@/i18n'
import { getApiErrorMessage } from '@/utils/error'

import { useInvalidateIglooCustomPin } from './get-igloo-custom-pin'

const resendIglooCustomPinEmail = async (clientId: string) => {
  const response = await authAPI.post(`/igloowork/${clientId}/custom-pin/resend`)
  return response.data
}

export const useResendIglooCustomPinEmail = (clientId: string) => {
  const invalidate = useInvalidateIglooCustomPin(clientId)
  return useMutation({
    mutationFn: () => resendIglooCustomPinEmail(clientId),
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: async () => {
      await invalidate()
      toastFactory.success(
        i18n.t('clients:keylessAccess.igloo.customPin.toasts.resendEmailSuccess'),
      )
    },
  })
}
